import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";

export const apiCallGetDataForMyAuditingPerformanceTable = async ({
  adminId,
  fromDate,
  toDate
}: {
  adminId: number;

  fromDate: Date;
  toDate: Date;
}): Promise<{
  data: {
    auditName: string;
    minor: number;
    major: number;
    no_issue: number;
    total: number;
  }[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<
    {
      auditName: string;
      minor: number;
      major: number;
      no_issue: number;
      total: number;
    }[]
  >(`auditor/getMyAuditingPerformance`, {
    adminId,

    dateMinObject: getDateAsObject(fromDate),
    dateMaxObject: getDateAsObject(toDate)
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
